import Trix from "trix"

import 'trix/dist/trix.css'
import("@rails/actiontext")

Trix.config.blockAttributes.heading1.tagName = "h2"


// prevents attachments:
document.addEventListener("trix-file-accept", function(event) {
  event.preventDefault();
});
